// CJS like context-source-matrix.js: the plain-node unit suite requires it directly.
//
// Field-def keys the DCE reads for its own pickers and the engine's validator
// does not know. It throws on the first instantiation of an entity carrying one,
// which a stateOnly filter write does on the published page -- so they are
// stripped from the def the engine registers and kept on the raw client payload.
// Mirrored by App::CLIENT_ONLY_FIELD_DEF_KEYS on the PHP side.
const CLIENT_ONLY_FIELD_DEF_KEYS = ["storyType"];

function stripClientOnlyFieldDefKeys(definition) {
  const fields = {};
  Object.entries(definition.fields || {}).forEach(([fieldName, fieldDef]) => {
    const kept = { ...fieldDef };
    CLIENT_ONLY_FIELD_DEF_KEYS.forEach(key => {
      delete kept[key];
    });
    fields[fieldName] = kept;
  });
  return { ...definition, fields };
}

module.exports = { CLIENT_ONLY_FIELD_DEF_KEYS, stripClientOnlyFieldDefKeys };
module.exports.default = module.exports;
